import { computed, ref, toRefs } from 'vue'
import forEach from 'dcode/functions/forEach'
import isSelected from 'dcode/functions/isSelected'
import useWatch from 'dcode/uses/useWatch'
import attrItem from '@/components/CItem/attrItem'

export default function useItems (props, context) {
  const {
    list,
    underline
  } = toRefs(props)

  const propGroup = ref(props.group || {})

  const getGroup = item => propGroup.value?.[item.value]
  const setGroup = item => {
    propGroup.value[item.value] = !getGroup(item)
  }
  const isEditGroup = item => item.value in propGroup.value

  const getItem = item => attrItem({
    props,
    items: item,
    attrs: {
      item,
      underline,
      focus: computed(() => isSelected(item.value, props.focus)),
      selected: computed(() => isSelected(item.value, props.selected))
    }
  })

  const getList = item => {
    if ('list' in item) {
      return {
        ...props,
        list: item.list,
        open: computed(() => isEditGroup(item) ? getGroup(item) : !!item.list.find(item => item.value === props.selected)),
        class: computed(() => {
          return { 'status-open': getGroup(item) }
        }),
        on: () => {
          setGroup(item)
          context.emit('on-group', { value: propGroup.value })
        }
      }
    } else {
      return undefined
    }
  }

  return useWatch(list, () => forEach(list.value, item => {
    if (
      item?.subtitle ||
      item?.space
    ) {
      return {
        value: item.value,
        subtitle: item?.subtitle,
        space: item?.space
      }
    } else {
      return {
        value: item.value,
        item: getItem(item),
        list: getList(item)
      }
    }
  }), ['init'])
}
